import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/app/admin/lms/curricula")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
